// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__rKX6G","overlayAppBanner":"Overlay_overlayAppBanner__C7UM2"};